export default __webpack_public_path__ + "static/media/campaign1.2ad38762.svg";